/**
 *
 * @param product
 * @deprecated Use CartLineItem instead (wip)
 */
export function createCartProductFromProduct(product) {
  const price = product.price.currencies[0].prices[0].price;
  const oldPrice = product.price.currencies[0].prices[0].oldPrice;
  return {
    title: product.descriptions[0].title,
    description: product.descriptions[0].long,
    quantity: 1,
    // This field don't exist in Product
    stock: product.stock.stock,
    price,
    oldPrice: oldPrice && oldPrice > price ? oldPrice : undefined,
    productId: product.id,
    image: product.imageUrl,
    currency: product.price.currencies[0].currency,
    type: 'digital',
    categories: product.categories,
    bundleProductsV4: product.bundleProductsV4,
    specificV4: product.specificV4,
    refID: product.refID,
    product
  };
}
